import * as React from 'react';

import { cn } from '@blockworks/ui/utils';

type PriceSponsoredByProps = {
    children: JSX.Element | React.ReactNode | string | null;
    title?: string;
    className?: string;
};

const PriceSponsoredBy = (props: PriceSponsoredByProps) => {
    const { children, className, title } = props;

    return (
        <div className={cn('flex justify-start items-center relative gap-2', className)}>
            <div className="flex justify-start items-center relative gap-1">
                <p className="text-sm text-left text-light-gray">{title}</p>
            </div>
            <div className="font-semibold">
                <>{children}</>
            </div>
        </div>
    );
};

export default PriceSponsoredBy;
